module.exports = ({
    "CDMS910MSG001": "คุณแน่ใจหรือไม่ว่าต้องการรีเซ็ตรหัสผ่าน?",
    "CDMS910MSG002": "รหัสผ่านของคุณได้รับการรีเซ็ตแล้ว รหัสผ่านใหม่ได้ถูกส่งไปยังอีเมลของคุณแล้ว",
    "CDMS910MSG003": "คุณต้องการปิดการใช้งานของผู้ใช้งานรายนี้หรือไม่?",
    "CDMS910MSG004": "คุณต้องการเปิดการใช้งานของผู้ใช้งานรายนี้หรือไม่?",
    "CDMS910H001": "รหัสผู้ใช้งาน",
    "CDMS910H002": "ชื่อผู้ใช้งาน",
    "CDMS910H003": "วันที่เริ่มต้น",
    "CDMS910H004": "วันที่สิ้นสุด",
    "CDMS910H005": "วันที่อัปเดตรหัสผ่านล่าสุด",
    "CDMS910H006": "องค์กร",
    "CDMS910H007": "ตำแหน่ง",
    "CDMS910H008": "สถานะ",
    "CDMS910H009": "รีเซ็ตรหัสผ่าน",
    "CDMS910H010": "Audit",
    "CDMS910H011": "No.",
    "CDMS910H012": "อีเมล",
    "CDMS910H013": "เบอร์โทรศัพท์",
    "CDMS910H014": "ผู้แก้ไข",
    "CDMS910H015": "วันที่แก้ไข",
    "CDMS910H016": "ปิดการใช้งาน",
    "CDMS910H017": "ภาษา",
    "CDMS910TT001": "การจัดการผู้ใช้งาน",
    "CDMS910TT002": "ประวัติการแก้ไขของ {userLoginId}",
    "CDMS910OPT001": "Active",
    "CDMS910OPT002": "Inactive",
    "CDMS910OPT003": "Locked",
    "CDMS910OPT004": "Not yet"
});
